import { APP_ASSETS_BASE_URL, ASSETS_CDN_BASE_URL } from "@/consts";

const CDNAssetMixin = {
  methods: {
    AppNetworkImage(path) {
      let pathVal = path.replace(/^\/+/g, "");

      if (this.$root.webpSupported === true) {
        var ext = path.split(/[#?]/)[0].split(".").pop().trim();
        switch (ext) {
          case "jpg":
            pathVal = pathVal.replace(".jpg", ".webp");
            break;
          case "png":
            pathVal = pathVal.replace(".png", ".webp");
            break;
        }
      }

      let base = APP_ASSETS_BASE_URL
        ? APP_ASSETS_BASE_URL
        : "https://assets.visitorscoverage.com/development/app";
      return `${base}/img/${pathVal}`;
    },
    AssetNetworkUrl(path) {
      let pathVal = path.replace(/^\/+/g, "");
      let base = ASSETS_CDN_BASE_URL
        ? ASSETS_CDN_BASE_URL
        : "https://assets.visitorscoverage.com/development";
      return `${base}/${pathVal}`;
    },
  },
};

export default CDNAssetMixin;
